module.exports = __webpack_public_path__ + "static/media/ExpressJS.4ec0a5b1.png";